<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchParams" :model="searchParams" label-width="80px" class="unitWidth" size="small">
                <el-form-item :label="$t('Shift.factory')">
                    <el-cascader
                        v-model="region"
                        :options="options"
                        :props="{ checkStrictly: true }"
                        :placeholder="$t('base.PleaseSelect')"
                        @change="searchTable" :clearable="isclear">
                        <template slot-scope="{ node, data }">
                            <span>{{ data.label }}</span>
                            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                        </template>
                    </el-cascader>
                </el-form-item>
                <el-form-item :label="$t('base.name')">
                    <el-input v-model.trim="searchParams.param.userName" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('base.JobNo')">
                    <el-input v-model.trim="searchParams.param.userAccount" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
            </el-form>
            <template slot="btns">
                <el-button size="small" type="primary" @click="searchTable()">{{$t('base.search')}}</el-button>
            </template>
        </SearchBox>
        <LabelContent :title="$t('User.UserList')" ref="LabelContent">
            <div slot="btns">
<!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                <span v-for="acc in access" :key="acc">
                    <el-button size="small" type="success" @click="addUser()" v-if="acc=='US0001'" style="margin-right:10px">{{$t('base.add')}}</el-button>
                    <el-button size="small" type="success" @click="userTemplate()" v-if="acc=='US0005'" style="margin-right:10px">{{$t('base.Mould')}}</el-button>
                    <el-button size="small" type="success" @click="userImport()" v-if="acc=='US0006'" style="margin-right:10px">{{$t('base.Import')}}</el-button>
                </span>
                <el-button size="small" type="success" @click="exportUser()">{{$t('base.export')}}</el-button>
                <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center" @selection-change="handleSelectionChange" @sort-change="sortChange">
<!--                <el-table-column type="selection" width="55" />-->
                <el-table-column prop="userAccount" :label="$t('base.JobNo')" show-overflow-tooltip />
                <el-table-column prop="userName" :label="$t('base.name')" show-overflow-tooltip />
                <el-table-column prop="userEmail" label="e-mail" show-overflow-tooltip />
<!--                <el-table-column prop="userPhone" label="联系方式" show-overflow-tooltip />-->
                <el-table-column prop="isActive" :label="$t('User.state')" show-overflow-tooltip >
                    <template slot-scope="scope">
                        <!-- <span>{{scope.row.isActive == true?$t('base.Enable'):$t('base.Disable')}}</span> -->
                        <span>{{scope.row.isActive == true?'启用':'不启用'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="wxQyUserid" :label="$t('User.WeChat')" show-overflow-tooltip >
                    <template slot-scope="scope">
                        <!-- <span>{{scope.row.hasOwnProperty('wxQyUserid') == true?$t('User.Yes'):$t('User.No')}}</span> -->
                        <span>{{scope.row.hasOwnProperty('wxQyUserid') == true?'是':'否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('base.operation')" width="120">
                    <template slot-scope="scope">
<!--                        <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />-->
                        <span v-for="acc in access" :key="acc">
                            <i class="refresh el-icon-refresh-right" @click="refreshUser(scope.row)" v-if="acc=='US0004'"/>
                        </span>
                        <span v-for="acc in access" :key="acc">
                            <i class="editBtn iconfont u-youjianbianji" @click="editUser(scope.row)" v-if="acc=='US0002'" />
                            <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" v-if="acc=='US0003'" />
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>

        <el-dialog :title="ifAdd ? '新增' : '修改'" width="700px" :visible.sync="updateShow" style="text-align: left">
            <div class="edit-box">
                <el-scrollbar class="Yscrollbar">
                    <el-form :inline="true" :model="userForm" :rules="rules" ref="userForm" label-width="100px" class="fform">
                        <el-form-item label="姓名" prop="userName">
                            <el-input v-model="userForm.userName"></el-input>
                        </el-form-item>
                        <el-form-item label="账号" prop="userAccount">
                            <el-input v-model="userForm.userAccount"></el-input>
                        </el-form-item>
                        <el-form-item label="工号" prop="empNumber">
                            <el-input v-model="userForm.empNumber"></el-input>
                        </el-form-item>
                        <el-form-item label="e-mail" prop="userEmail">
                            <el-input v-model="userForm.userEmail"></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式" prop="userPhone">
                            <el-input v-model="userForm.userPhone"></el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-switch v-model="isActiveFormat"></el-switch>
                        </el-form-item>
                        <el-form-item label="绑定角色">
                            <el-select v-model="bindRoles" multiple @change="bindRole">
                                <!-- <el-select v-model="bindRoles" @change="bindRole"> -->
                                <el-option v-for="item in roleList" :label="item.roleName" :value="item.roleId" :key="item.roleId" />
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button style="float:left" type="warning" v-if="!ifAdd" @click="resetPwd">重置密码</el-button>
                <el-button @click="updateShow = false">取 消</el-button>
                <el-button type="primary" @click="updateComf()">{{ ifAdd ? '新增' : '修改' }}</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="$t('User.UserImport')" :visible.sync="userImportShow">
            <el-upload
                class="upload-demo"
                drag
                :headers="{'X-Auth-Token':token}"
                :action="URL"
                :on-success="itemSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{$t('msg.Drag')}} <em>{{$t('msg.Upload')}}</em></div>
            </el-upload>
        </el-dialog>
    </div>
</template>
<script>
    import { deleteSave, depart_tree, getAllUserList, userImport, userTestExport } from '../../../libs/api'
    import jQuery from 'jquery'
export default {
    name: 'User',
    computed: {
        isActiveFormat: {
            get() {
                return this.userForm.isActive ? true : false
            },
            set(newValue) {
                this.userForm.isActive = newValue ? 1 : 0
            }
        }
    },
    data() {
        return {
            searchParams: {
                param: {
                    userName: '',
                    startTime: null,
                    endTime: null,
                    userPhone: '',
                    empNumber: '',
                    userAccount:''
                },
                pageSize: 10,
                page: 1,
                pageCount: 0
            },
            region:[],
            options:[],
            total: 0,
            tableData: [],
            ifAdd: false,
            updateShow: false,
            bindRoles: [],
            roleList: [],
            userForm: {
                createTime: String,
                createUserId: Number,
                empNumber: String,
                isActive: Boolean,
                updateUserId: Number,
                userAccount: String,
                userEmail: String,
                userId: Number,
                userName: String,
                userPasswd: String,
                userPhone: String
            },

            rules: {
                userName: [
                    {
                        type: 'string',
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                userAccount: [
                    {
                        type: 'string',
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                empNumber: [
                    {
                        type: 'string',
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                userEmail: [
                    {
                        type: 'string',
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                userPhone: [
                    {
                        type: 'string',
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ]
            },
            access:[],
            ischeck:true,
            roles:[],
            isclear:false,
            fctypes:[],
            fcList:'',
            token:'',
            URL:'',
            userImportShow:false,
            userSpeArray:{}
        }
    },
    mounted() {
        this.init()
    },
    activated() {
        this.init()
    },
    methods: {
        init(){
            var userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
            this.access = JSON.parse(sessionStorage.getItem('auths'))
            this.userInfo = this.$store.state.userInfo
            this.token = sessionStorage.getItem('authToken')
            this.region = []
            this.fcList = ''
            if(this.userInfo.factoryId == 0){
                //所有工厂数据
                this.ischeck = false;
                this.isclear = true
            }else{
                this.roles = userInfo.roles
                for (let i = 0; i < userInfo.roles.length; i++) {
                    if(i == userInfo.roles.length - 1){
                        this.fcList += userInfo.roles[i].fcCode
                    }else{
                        this.fcList += userInfo.roles[i].fcCode + ','
                    }
                }
                this.region.push(this.userInfo.fcCode)
            }
            /*if (this.$route.params.userSpe != undefined && this.$route.params.userSpe != '') {
                this.userSpeArray = this.$route.params.userSpe
                if(this.ischeck){
                    this.region = []
                    if(this.userSpeArray.hasOwnProperty('fcCode')){
                        this.region.push(this.userSpeArray.fcCode)
                        if(this.userSpeArray.hasOwnProperty('shopCode')){
                            this.region.push(this.userSpeArray.shopCode)
                        }
                    }
                }else{
                    if(this.userSpeArray.hasOwnProperty('fcCode')){
                        this.region.push(this.userSpeArray.fcCode)
                        if(this.userSpeArray.hasOwnProperty('shopCode')){
                            this.region.push(this.userSpeArray.shopCode)
                        }
                    }
                }
                this.searchParams.param.userName = this.userSpeArray.userName
                this.searchParams.param.userAccount = this.userSpeArray.userEmpNumber
            }*/
            // this.queryRole()
            this.departTree()
        },
        /**
         * 查询工厂级联
         **/
        departTree(){
            let queryParams = {
                from:'manage',
                fcList:this.fcList
            }
            let options = {
                method: 'GET',
                params: queryParams,
                url: this.$api.depart_tree
            }
            this.$http.request(options).then(response => {
                if(response.status == 100) {
                    this.setRegion(response.data)
                    this.searchTable()
                }
            })
        },
        setRegion(fctypes){
            fctypes.forEach(result => {
                result.label = result.deptName
                result.value = result.deptCode
                result.children = result.child
                if(result.child != null){
                    if(result.child.length > 0){
                        this.setRegion(result.child)
                    }
                }
            })
            this.options = fctypes
        },
         /**
         *查询用户列表
         *  查询参数对象 searchParams
         **/
        searchTable() {
            let queryParams = {
                pageSize: this.searchParams.pageSize,
                pageNum: this.searchParams.page
            }
            if(this.searchParams.param.userName != null && this.searchParams.param.userName != ''){
                queryParams["userName"] = this.searchParams.param.userName
            }
            if(this.searchParams.param.userAccount != null && this.searchParams.param.userAccount != ''){
                queryParams["userAccount"] = this.searchParams.param.userAccount
            }
            if(this.region.length != 0){
                var arr = ''
                for (let i = 0; i < this.region.length; i++) {
                    if(i == this.region.length-1){
                        arr += this.region[i]
                    }else{
                        arr += this.region[i] + ','
                    }
                }
                queryParams["region"] = arr
            }
            let options = {
                method: 'GET',
                params: queryParams,
                url: this.$api.getAllUserList
            }
            this.$http.request(options).then(response => {
                if(response.status == 100) {
                    this.tableData = response.data.data.list
                    this.searchParams.pageCount = response.data.total;
                }
            })
        },
        addUser(){
            this.$router.push({path:'/addUser'})
        },
        async exportUser(){
            let params = {}
            params['language'] = this.$t('lang')
            if(this.searchParams.param.userName != undefined && this.searchParams.param.userName != ''){
                params['userName'] = this.searchParams.param.userName
            }
            if(this.searchParams.param.userAccount != undefined && this.searchParams.param.userAccount != ''){
                params['userAccount'] = this.searchParams.param.userAccount
            }
            if(this.region.length != 0){
                var arr = ''
                for (let i = 0; i < this.region.length; i++) {
                    if(i == this.region.length-1){
                        arr += this.region[i]
                    }else{
                        arr += this.region[i] + ','
                    }
                }
                params["region"] = arr
            }
            let options = {
                url:this.$api.exportUser,
                method:'POST',
                params:params,
                responseType: 'blob',
                headers: {
                    "Content-Type": "application/json;application/ms-excel;application/ms-excel;charset=utf-8"
                }
            }
            this.$http.config.timeout = 30000
            let result = await this.$http.request(options)
            var elink = document.createElement('a')
            elink.download = this.$t('User.UserInfo')  //设置名称
            elink.style.display = 'none'
            var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)  //追加节点
            elink.click()
            document.body.removeChild(elink)  //删除节点
        },
        //用户导入模板
        userTemplate(){
            if(this.region.length == 0){
                this.$message.error(this.$t('mechanism.selectFc'))
                return;
            }
            var inputs = '';
            var lang = this.$t('lang');
            inputs += '<input type="hidden" name="token" value="' + this.token + '" />'
            inputs += '<input type="hidden" name="language" value="' + lang + '" />'
            if(this.region[0] != '' && this.region[0] != undefined ){
                inputs += '<input type="hidden" name="fcCode" value="' + this.region[0] + '" />';
            }
            var url = this.$api.userTemplate
            // var url = this.$api.userTestExport

            jQuery('<form action="' + url + '" method=POST>' + inputs + '</form>')
                .appendTo('body').submit().remove();
        },
        //用户导入
        userImport(){
            if(this.region.length == 0){
                this.$message.error(this.$t('mechanism.selectFc'))
                return;
            }
            if(this.region[0] != '' && this.region[0] != undefined ) {
                this.userImportShow = true
                this.URL = this.$api.userImport + '?fcCode=' + this.region[0] + '&language=' + this.$t('lang')
            }
        },
        itemSuccess(resp){
            if (resp.status == 101) {
                alert(resp.message)
            } else if (resp.status == 100) {
                this.$message.success(this.$t('base.ImportSucceeded'))
                this.userImportShow = false
                this.searchTable()
            }
        },
        //分页
        paginationChange(val) {
            this.searchParams.pageSize = val
            this.searchTable()
        },
        paginationCurrentChange(val){
            this.searchParams.page = val
            this.searchTable()
        },
        //多选框选择 返回当前已选行数据(Array)
        handleSelectionChange(val) {
            console.log(val)
        },
        //从后台获取数据,重新排序
        sortChange(val) {
            // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
            console.log(val)
        },
        //自定义排序规则 sort-method
        sortByDate(a, b) {
            console.log(a, b)
            if (a < b) return -1
        },
        //绑定权限
        bindRole() {
            this.$http
                .request({
                    method: 'POST',
                    headers: { 'content-type': 'application/json' },
                    data: {
                        userId: this.userForm.userId,
                        roleIds: this.bindRoles
                    },
                    url: '/api/user/bindRole'
                })
                .then(response => {
                    if (response.status != 100) {
                        this.$message.error('绑定失败！')
                    }
                    this.$message.success('绑定成功!')
                })
                .catch(err => {})
        },
        //编辑框打开
        updatehOpen(row) {
            if (this.ifAdd) {
                //新增
                this.userForm = {
                    createTime: this.getDateTime(),
                    createUserId: null,
                    empNumber: '',
                    isActive: true,
                    updateUserId: null,
                    userAccount: null,
                    userEmail: '',
                    userId: null,
                    userName: '',
                    userPasswd: '',
                    userPhone: ''
                }
                this.updateShow = true
            } else {
                this.userForm = JSON.parse(JSON.stringify(row))
                this.queryRolebyUser()
                this.updateShow = true
            }
        },
        queryRolebyUser() {
            this.bindRoles = []
            this.$http
                .request({
                    method: 'POST',
                    headers: { 'content-type': 'application/json' },
                    data: { userId: this.userForm.userId },
                    url: '/api/user/userRole'
                })
                .then(response => {
                    if (response.status != 100) {
                        this.$message.error(response.message)
                    } else {
                        let list = response.data
                        console.log(list)
                        for (let r in response.data) {
                            this.bindRoles.push(list[r].roleId)
                        }
                    }
                })
                .catch(err => {
                    this.$message.error(err)
                })
        },
        //编辑框确认
        updateComf() {
            if (!this.submitForm('userForm')) return
            let userUrl = '/api/user/add'
            if (!this.ifAdd) {
                this.$http
                    .request({
                        method: 'POST',
                        headers: { 'content-type': 'application/json' },
                        data: this.userForm,
                        url: '/api/user/update'
                    })
                    .then(response => {
                        if (response.status != 100) {
                            this.$message.error(response.message)
                        }
                        this.updateShow = false
                        this.searchTable()
                    })
                    .catch(err => {
                        this.$message.error(err)
                        this.updateShow = false
                        this.searchTable()
                    })
            } else {
                this.$http
                    .request({
                        method: 'POST',
                        headers: { 'content-type': 'application/json' },
                        data: this.userForm,
                        url: userUrl
                    })
                    .then(response => {
                        if (response.status != 100) {
                            this.$message.error(response.message)
                        }
                        this.updateShow = false
                        this.searchTable()
                    })
                    .catch(err => {
                        this.$message.error(err)
                        this.updateShow = false
                        this.searchTable()
                    })
            }
        },
        editUser(row){
            this.$router.push({
                    name:'editUser',
                    params: {
                        row:row
                    }
            })
        },
        refreshUser(row){
            console.log('row',row)
            if(row.hasOwnProperty('wxQyUserid')){
                this.$confirm(this.$t('User.Tips'), this.$t('msg.Tips'), {
                confirmButtonText: this.$t('base.confirm'),
                cancelButtonText: this.$t('base.cancel'),
                type: 'warning'
            })
                .then(() => {
                    this.$http
                        .request({
                            method: 'POST',
                            params: { userId: row.userId },
                            url: this.$api.userReset
                        })
                        .then(response => {
                            this.searchTable()
                            // this.$message.success(response.message);
                        })
                        .catch(err => {
                            this.searchTable()
                            // this.$message.error(err);
                        })
                })
                .catch(() => {
                    this.searchTable()
                    this.$message({
                        type: 'info',
                        message: this.$t('msg.canceled')
                    })
                })
            }else{
                this.$message({ type: 'error', message: this.$t('User.noWX') })
            }
        },
        deleteRow(row) {
            this.$confirm(this.$t('msg.TipsText'), this.$t('msg.Tips'), {
                confirmButtonText: this.$t('base.delete'),
                cancelButtonText: this.$t('base.cancel'),
                type: 'warning'
            })
                .then(() => {
                    this.$http
                        .request({
                            method: 'POST',
                            params: { userId: row.userId },
                            url: this.$api.deleteSave
                        })
                        .then(response => {
                            this.searchTable()
                            // this.$message.success(response.message);
                        })
                        .catch(err => {
                            this.searchTable()
                            // this.$message.error(err);
                        })
                })
                .catch(() => {
                    this.searchTable()
                    this.$message({
                        type: 'info',
                        message: this.$t('msg.cancel')
                    })
                })
        },
        resetPwd() {
            this.$confirm('是否确定重置密码, 是否继续?', '提示', {
                confirmButtonText: '重置',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$http
                        .request({
                            method: 'POST',
                            headers: { 'content-type': 'application/json' },
                            data: { userId: this.userForm.userId },
                            url: '/api/user/user_repassword'
                        })
                        .then(response => {
                            if (response.status == 100) {
                                this.$message.success('密码已重置')
                            }
                            this.searchTable()
                            // this.$message.success(response.message);
                        })
                        .catch(err => {
                            this.searchTable()
                            // this.$message.error(err);
                        })
                })
                .catch(() => {
                    this.searchTable()
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        queryRole() {
            let options = {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                data: {
                    pageSize: 999,
                    page: 1,
                    pageCount: 0
                },
                url: '/api/role/pageQuery'
            }
            this.$http.request(options).then(response => {
                if (response.status === 100) {
                    this.roleList = response.data
                }
            })
        },
        //表单验证
        submitForm(formName) {
            let result = true
            this.$refs[formName].validate(valid => {
                if (valid) {
                    result = true
                } else {
                    result = false
                }
            })
            return result
        }
    }
}
</script>

<style lang="scss" scoped>
.fform {
    .el-form-item {
        margin-bottom: 30px !important;
    }
}
</style>
